import React, { useCallback, useContext, useState } from "react";
import { useDropzone } from "react-dropzone";
import request from "../../services/request";
import { useTranslation } from "react-i18next"; /* Added Line */
import { ThemeContext } from '../../../context/ThemeContext';

FileUpload.propTypes = {};

function FileUpload({
  field,
  form,
  ...props
}) {
  const { changeSpinnerStatus } = useContext(ThemeContext);
  const [progress, setProgress] = useState(0);
  const [t] = useTranslation();
  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length > 0) {
      const formData = new FormData();
      setProgress(0);
      acceptedFiles.forEach((file) => {
        formData.append("file", file);
      });
      request({
        method: "post",
        url: "file/upload",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setProgress(percentCompleted);
        }
      }, changeSpinnerStatus).then((response) => {
        if (response.responseStatus === "SUCCESS") {
          addFile(response.body.tableData);
        }
      },);
    }
  };

  const addFile = (files) => {
    if (!field.value) {
      field.value = [];
    }
    files.forEach((td) => {
      field.value.push({ id: td.id, path: td.fileName + td.extension });
    });
    form.setFieldValue(field.name, field.value);
  };

  const removeFile = (file) => {
    form.setFieldValue(
      field.name,
      field.value.filter((f) => f.id != file.id)
    );
  }

  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    onDrop: (droppedFiles) => onDrop(droppedFiles),
  });

  

  return (
    <div
      className={"form-group input-group-lg col-md-" + (props.colNumber || 4)}
    >
      <label className="text-black font-w600">
        {props.required ? "*" : ""}
        {t("demandCreate.dosya")}
      </label>
      <div
        {...getRootProps({
          style: {
            flex: 1,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "20px",
            borderWidth: 2,
            borderRadius: 2,
            borderColor: "#eeeeee",
            borderStyle: "dashed",
            backgroundColor: "#fafafa",
            color: "#bdbdbd",
            outline: "none",
            transition: "border .24s ease-in-out",
          },
        })}
      >
        <input {...getInputProps()} />
        <p>{t("fileUpload.dosyaUpload")}</p>
      </div>
      <div className="progress rounded-0" style={{ height: "20px" }}>
        <div className="progress-bar bg-success" role="progressbar" style={{ width: progress + "%" }} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">{progress === 100 ? t("fileUpload.uploadSuccess") : progress + "%"}</div>
      </div>
      <aside>
        <ul>
          {field.value &&
            field.value.map((file) => {
              return (
                <li
                  key={file.path}
                  style={{
                    border: "1px solid #9E2A44",
                    marginTop: "15px",
                    marginBottom: "3px",
                    width: "fit-content",
                    borderRadius: "15px",
                    color: "black",
                    padding: "0px 7px",
                  }}
                >
                  {file.path}
                  {/* {file.size} bytes  */}
                  <button
                    className="btn btn-sm"
                    style={{ color: "#9E2A44" }}
                    title="Kaldır"
                    onClick={() => removeFile(file)}
                  >
                    {" "}
                    X{" "}
                  </button>
                </li>
              );
            })}
        </ul>
      </aside>
      {props.required && <small>{t('formFields.required')}</small>}
    </div>
  );
}

export default FileUpload;
